import { IRawStyle } from "@fluentui/react/lib/Styling";
import { IPalette } from "@fluentui/react/lib/Theme";

export interface ITheme {
  dark: IPalette;
  default: ThemeType;
  light: IPalette;
  font: IRawStyle;
}

export enum ThemeType {
  Auto = `auto`,
  Dark = `dark`,
  Light = `light`
}
